module.exports = __webpack_public_path__ + "img/telegramicon.566bc041.png";